// Voorleesknop op het bord (readAloud.nl.ts): de schakelaar per gezinslid in de ouderapp.
export const appReadAloudNl = {
    setting: 'Voorleesknop op het bord',
    settingHint: 'Een grote knop leest taken, afspraken en berichten voor. Handig voor wie nog niet leest.',
    language: 'Taal van voorlezen en oproepen',
    languageHint: 'Het bord leest taken, afspraken en oproepen in deze taal voor. Titels worden voorgelezen zoals je ze typt.',
    languageBoard: 'Taal van het bord ({language})',
    languageMember: 'Taal van voorlezen',
    languageMemberHint: 'Titels worden voorgelezen zoals je ze typt.',
    languageFamily: 'Zoals het gezin ({language})',
    saved: 'Opgeslagen',
};
//# sourceMappingURL=readAloudApp.nl.js.map